export function isObjectId(id: any): id is string {
    if (!id) {
        return false;
    }
    const str: string = (id && typeof id !== 'string') ? id.toString() : id;
    return !!str.match(/^[0-9a-fA-F]{24}$/);
}